/**
 * FASE 05 — Ajustes 25/08 (plano de mídias, Etapa C — item 12 do docx de 22/08).
 *
 * Nome sugerido para a mídia quando o cadastro é NOVO e o campo não foi informado:
 * código do produto + a extensão da aba.
 *
 *   Ícone: <código>.BMP · Figura: <código>.PNG · Ficha técnica: <código>.PDF
 *
 * É só um PADRÃO (decisão F05A-P3a de 26/08): o nome não é derivado do código por regra —
 * produtos que só diferem pela cor compartilham a mesma mídia, e nesses casos o usuário
 * troca o nome à mão. Por isso nunca sobrescreve valor já existente, e não vale para
 * cadastro em edição.
 */
export type ExtensaoMidia = ".BMP" | ".PNG" | ".PDF";

export function nomeArquivoPadrao(
  codigoProduto: string | undefined,
  extensao: ExtensaoMidia,
  ehCadastroNovo: boolean,
  nomeAtual?: string
): string {
  if (nomeAtual?.trim()) return nomeAtual;
  if (!ehCadastroNovo) return "";

  const codigo = (codigoProduto ?? "").trim();
  return codigo ? `${codigo}${extensao}` : "";
}
